import * as userSelectors from '@/user/user-selectors';
import { useSelector } from 'react-redux';
import { UserProfileForm } from './user-profile-form';
import * as Profile from './user-profile-styles';

export function UserProfile() {
  const displayCitySelection = useSelector(userSelectors.displayCitySelection);

  return (
    <Profile.Background>
      <UserProfileForm displayCitySelection={displayCitySelection} />
    </Profile.Background>
  );
}
